import React, { Component, useRef, useEffect } from "react";
import BasicLayout from "../layouts/Basic";
import Responsive from "../layouts/Responsive";

import Title from "../components/Title";

import Room from "../sketches/Room";

const Noroom = () => {
  return (
    <>
      <Responsive />
      <div className="book-wrapper">
        <div className="left-con">
          {/* <Title /> */}
          <div className="contents-wrapper">
            <div className="canvas-wrapper">
              <Room />
            </div>
            <div className="element-wrapper">
              <div className="clip"></div>
            </div>
          </div>
        </div>
        <BasicLayout />
      </div>
    </>
  );
};

export default Noroom;
